/* ==========================================================================
   LyfespanX — Theme 2026 (Shopify)
   Overlays, Warenkorb (AJAX + Section Rendering), Kaufoptionen, Galerie,
   Routine-Finder, Vorschlagssuche. Ohne externe Bibliotheken.
   ========================================================================== */
(() => {
  'use strict';
  if (window.__lxInit) return; window.__lxInit = true;

  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));
  const readJSON = (id, d) => { try { const el = document.getElementById(id); return el ? JSON.parse(el.textContent) : d; } catch (e) { return d; } };
  const CFG = readJSON('lx-config', {});
  const R = Object.assign({ root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', search: '/search', predictive: '/search/suggest' }, CFG.routes || {});
  const P = readJSON('lx-products', {});
  const reduceMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const eur = c => (Math.round(c) / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  const icon = (id, cls) => `<svg${cls ? ` class="${cls}"` : ''} aria-hidden="true" focusable="false"><use href="#${id}"/></svg>`;
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- Toast ---------- */
  let toastT;
  function toast(msg) {
    const t = $('#toast'), tt = $('#toast-t'); if (!t || !tt) return;
    tt.textContent = msg; t.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove('is-on'), 4200);
  }

  /* ---------- Overlays: Warenkorb, Menü, Suche, Finder ---------- */
  const PANELS = { cart: '#cart', menu: '#menu', search: '#search', finder: '#finder-modal' };
  let openPanel = null, lastFocus = null, modalFinder = null;
  function openOverlay(name) {
    if (name === 'cart' && CFG.template === 'cart') return false;
    const el = $(PANELS[name]); if (!el) return false;
    if (openPanel === name) return true;
    closeOverlays(true);
    lastFocus = document.activeElement;
    if (name === 'finder') {
      const body = $('#finder-modal-body');
      if (body) { if (!modalFinder) modalFinder = makeFinder(body); else modalFinder.reset(); }
    }
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
    const sc = $('#scrim'); if (sc) sc.classList.add('is-open');
    document.body.classList.add('is-locked');
    $$(`[aria-controls="${el.id}"]`).forEach(b => b.setAttribute('aria-expanded', 'true'));
    openPanel = name;
    closeMega();
    setTimeout(() => {
      const f = name === 'search' ? $('#q') : el.querySelector('input:not([type=hidden]), button:not([disabled]), a[href]');
      if (f) f.focus({ preventScroll: true });
    }, 60);
    return true;
  }
  function closeOverlays(silent) {
    Object.values(PANELS).forEach(s => { const el = $(s); if (el) { el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); $$(`[aria-controls="${el.id}"]`).forEach(b => b.setAttribute('aria-expanded', 'false')); } });
    const sc = $('#scrim'); if (sc) sc.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    const was = openPanel; openPanel = null;
    if (!silent && was && lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') { if (openPanel) closeOverlays(); closeMega(); }
    if (e.key === 'Tab' && openPanel) {
      const el = $(PANELS[openPanel]); if (!el) return;
      const f = $$('a[href], button:not([disabled]), input:not([type=hidden]), select, textarea, [tabindex]:not([tabindex="-1"])', el).filter(x => x.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Mega-Menü ---------- */
  let megaT;
  const navShop = () => $('#nav-shop');
  const mega = () => $('#mega');
  function openMega() { const m = mega(), n = navShop(); if (!m || !n) return; clearTimeout(megaT); m.classList.add('is-open'); n.classList.add('is-open'); n.setAttribute('aria-expanded', 'true'); }
  function closeMega() { const m = mega(), n = navShop(); if (!m || !n) return; m.classList.remove('is-open'); n.classList.remove('is-open'); n.setAttribute('aria-expanded', 'false'); }
  function initMega() {
    const n = navShop(), m = mega(); if (!n || !m || n.dataset.bound) return; n.dataset.bound = '1';
    n.addEventListener('click', () => m.classList.contains('is-open') ? closeMega() : openMega());
    n.addEventListener('mouseenter', () => { if (matchMedia('(hover:hover)').matches) openMega(); });
    [n, m].forEach(el => el.addEventListener('mouseleave', () => { megaT = setTimeout(closeMega, 180); }));
    m.addEventListener('mouseenter', () => clearTimeout(megaT));
    m.addEventListener('click', e => { if (e.target.closest('a,button')) closeMega(); });
  }

  /* ---------- Header: beim Runterscrollen ausblenden ---------- */
  let lastY = window.scrollY;
  window.addEventListener('scroll', () => {
    const hdr = $('#hdr'); if (!hdr) return;
    const y = window.scrollY;
    hdr.classList.toggle('is-scrolled', y > 8);
    const m = mega();
    const hide = y > 260 && y > lastY + 4 && !openPanel && !(m && m.classList.contains('is-open'));
    if (hide) hdr.classList.add('is-hidden'); else if (y < lastY - 4 || y < 260) hdr.classList.remove('is-hidden');
    lastY = y;
  }, { passive: true });

  /* ---------- Warenkorb ---------- */
  function updateCount(n) {
    const cc = $('#cart-count'); if (!cc) return;
    const old = parseInt(cc.textContent, 10) || 0;
    cc.textContent = n; cc.classList.toggle('has', n > 0);
    if (n > old) { cc.classList.remove('bump'); void cc.offsetWidth; cc.classList.add('bump'); }
    const a = $('a[data-open="cart"]'); if (a) a.setAttribute('aria-label', `Warenkorb öffnen, ${n} ${n === 1 ? 'Packung' : 'Packungen'}`);
  }
  // Fokus im Warenkorb nach dem Neuaufbau an gleicher Stelle halten (Tastatur, Screenreader)
  const FOCUSABLE = 'a[href], button:not([disabled]), textarea, input:not([type=hidden])';
  function focusMark() {
    const ae = document.activeElement, root = ae && ae.closest && ae.closest('#cart-body, #cart-foot, [data-lx-cart-page]');
    if (!root) return null;
    const xs = ae.hasAttribute('data-xs') ? $$('[data-xs]', root).indexOf(ae) : -1;   // „+“: nächstes „+“ an gleicher Stelle
    return { id: root.id || null, page: root.hasAttribute('data-lx-cart-page'), i: $$(FOCUSABLE, root).indexOf(ae), xs };
  }
  function focusRestore(m) {
    if (!m || (document.activeElement && document.activeElement !== document.body && document.contains(document.activeElement))) return;
    const root = m.page ? $('[data-lx-cart-page]') : document.getElementById(m.id);
    const xsb = root && m.xs >= 0 ? $$('[data-xs]', root) : [];
    const els = xsb.length ? xsb : (root ? $$(FOCUSABLE, root) : []);
    const el = els[Math.min(Math.max(xsb.length ? m.xs : m.i, 0), els.length - 1)];
    if (el) el.focus({ preventScroll: true }); else { const t = $('#cart-title'); if (t) { t.tabIndex = -1; t.focus({ preventScroll: true }); } }
  }
  function cartSay(msg) {
    const l = $('#cart-live');
    if (openPanel === 'cart' && l) { l.textContent = ''; setTimeout(() => { l.textContent = msg; }, 60); }
    else toast(msg);
  }
  function renderSections(sections) {
    if (!sections) return;
    const fm = focusMark();
    renderCartSections(sections);
    focusRestore(fm);
  }
  function renderCartSections(sections) {
    const html = sections['cart-drawer'];
    if (html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      ['cart-n', 'cart-ship', 'cart-body', 'cart-foot'].forEach(id => {
        const a = doc.getElementById(id), b = document.getElementById(id);
        if (a && b) { b.innerHTML = a.innerHTML; b.hidden = a.hidden; }
      });
      const src = doc.getElementById('cart');
      if (src) { const n = parseInt(src.dataset.count, 10) || 0; const dst = $('#cart'); if (dst) dst.dataset.count = n; updateCount(n); }
    }
    const page = $('[data-lx-cart-page]');
    if (page && sections[page.dataset.section]) {
      const doc = new DOMParser().parseFromString(sections[page.dataset.section], 'text/html');
      const src = doc.querySelector('[data-lx-cart-page]');
      if (src) page.innerHTML = src.innerHTML;
    }
  }
  function sectionIds() {
    const ids = ['cart-drawer'];
    const page = $('[data-lx-cart-page]'); if (page && page.dataset.section) ids.push(page.dataset.section);
    return ids.join(',');
  }
  async function cartPost(url, body) {
    const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(Object.assign(body, { sections: sectionIds(), sections_url: location.pathname })) });
    let data = {};
    try { data = await res.json(); } catch (e) { /* leere Antwort */ }
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Das hat leider nicht geklappt. Bitte versuche es erneut.');
    renderSections(data.sections);
    await syncCart(data);
    document.dispatchEvent(new CustomEvent('lx:cart-updated', { detail: data }));
    return data;
  }
  // Packungen im Warenkorb: Einmalkauf (Mix & Match, Höchstmenge) und Sparabo (Höchstmenge je Lieferung)
  const CART = Object.assign({ once: 0, sub: 0 }, CFG.cart || {});
  const MAX_ONCE = CFG.maxOnce || 6, MAX_SUB = CFG.maxSub || 3;
  // Mix & Match: Stufen [Packungen, Wert] – Wert in Prozent (tierType „pct“) oder fester Betrag je Packung in Cent („amt“)
  const TIER_AMT = CFG.tierType === 'amt';
  const TIERS = (CFG.tiers || [[2, 10], [3, 15], [4, 20]]).slice().sort((a, b) => b[0] - a[0]);
  const tierRow = n => TIERS.find(x => n >= x[0]);
  const tierMin = () => (TIERS.length ? TIERS[TIERS.length - 1][0] : 0);
  // Rabatt je Packung in Cent (Prozent: Shopify rundet je Packung auf ganze Cent ab)
  const tierOff = (price, n) => { const t = tierRow(n); if (!t) return 0; return Math.min(price, TIER_AMT ? t[1] : Math.floor(price * t[1] / 100)); };
  // Rabatt in ganzen Prozent (fester Betrag: abgerundet, bezogen auf den Preis)
  const tierPct = (n, price) => { const t = tierRow(n); if (!t) return 0; if (!TIER_AMT) return t[1]; return price ? Math.floor(tierOff(price, n) * 100 / price) : 0; };
  const tierTotal = (price, n, pctN) => (price - tierOff(price, pctN == null ? n : pctN)) * n;
  function countCart(c) {
    let once = 0, sub = 0;
    (c.items || []).forEach(it => { if (it.selling_plan_allocation) sub += it.quantity; else once += it.quantity; });
    CART.once = once; CART.sub = sub;
  }
  async function syncCart(data) {
    try {
      if (data && Array.isArray(data.items) && data.item_count != null) countCart(data);
      else countCart(await fetch(R.cart + '.js', { headers: { Accept: 'application/json' } }).then(r => r.json()));
    } catch (e) { /* Zähler bleiben unverändert */ }
  }
  const limitMsg = sub => sub
    ? `Im ${CFG.subLabel || 'Sparabo'} sind höchstens ${MAX_SUB} Packungen je Lieferung möglich.`
    : `Höchstens ${MAX_ONCE} Packungen je Bestellung. Für größere Mengen schreib uns an service@lyfespanx.com.`;
  const cartAdd = items => cartPost(R.cartAdd + '.js', { items });
  const cartChange = (key, quantity) => cartPost(R.cartChange + '.js', { id: key, quantity });
  // Position auf Abo umstellen (Verkaufsplan); laut Shopify per Zeilennummer, Menge immer mitgeben
  const cartPlan = (line, quantity, plan) => cartPost(R.cartChange + '.js', { line, quantity, selling_plan: plan });

  function flashDone(btn, label) {
    if (!btn) return;
    btn.classList.add('is-done');
    const lbl = btn.querySelector('.lbl') || btn.querySelector('span');
    const old = lbl ? lbl.textContent : null;
    if (lbl) lbl.textContent = label || 'Hinzugefügt';
    setTimeout(() => { btn.classList.remove('is-done'); if (lbl && old != null) lbl.textContent = old; }, 1600);
  }

  /* ---------- Kaufoptionen auf der Produktseite: Einzelkauf · Mix & Match · Sparabo ---------- */
  function initBuy(form) {
    if (form.dataset.bound) return; form.dataset.bound = '1';
    const sec = form.closest('.shopify-section') || document;
    const price = parseInt(form.dataset.price, 10) || 0;
    let qty = 1;
    const qIn = $('[data-qty-input]', form), pIn = $('[data-plan-input]', form), out = $('[data-qty-out]', form);
    const priceTag = $('[data-add-price]', form), hint = $('[data-hint]', form), btn = $('[data-add-btn]', form);
    const minus = $('[data-step="-1"]', form), plus = $('[data-step="1"]', form);
    const sticky = $('[data-sticky]', sec);
    const radio = () => $('input[name="lx_mode"]:checked', form);
    const mode = () => { const r = radio(); return r ? r.value : (form.dataset.mode || 'once'); };
    const plan = () => $('input[name="lx_plan"]:checked', form);
    const setMode = m => { const r = $(`input[name="lx_mode"][value="${m}"]`, form); if (r && !r.checked) r.checked = true; };
    const room = m => Math.max(0, m === 'sub' ? MAX_SUB - CART.sub : MAX_ONCE - CART.once);
    // Mix & Match: vorausgewählte Stufe = Stufe mit Hinweis „Beliebt“ (data-rec)
    const recN = () => { const x = $('input[name="lx_tq"][data-rec]', form); return (x && parseInt(x.value, 10)) || 3; };
    function total() {
      const m = mode();
      if (m === 'sub') { const p = plan(); return (p ? parseInt(p.dataset.price, 10) : price) * qty; }
      return tierTotal(price, qty, CART.once + qty);
    }
    function label() {
      const m = mode();
      if (m === 'sub') { const p = plan(); return p ? p.dataset.label : (CFG.subLabel || 'Sparabo'); }
      if (qty > 1) return `Mix & Match · ${qty} Packungen`;
      return 'Einzelkauf';
    }
    function update() {
      let m = mode();
      const r = room(m);
      // Menge in den Grenzen halten; Einzelkauf ⇄ Mix & Match über die Menge
      if (m !== 'sub') {
        if (m === 'tier' && qty < 2) qty = Math.min(recN(), Math.max(2, r));
        qty = Math.max(1, Math.min(qty, Math.max(1, r)));
        if (qty >= 2 && $('input[name="lx_mode"][value="tier"]', form)) { setMode('tier'); m = 'tier'; }
        else if (qty < 2) { setMode('once'); m = 'once'; }
        const tqs = $$('input[name="lx_tq"]', form), tqTop = tqs.reduce((a, t) => Math.max(a, parseInt(t.value, 10) || 0), 0);
        tqs.forEach(t => { const v = parseInt(t.value, 10); t.checked = v === qty || (v === tqTop && qty > tqTop); t.disabled = v > Math.max(1, r); });
      } else {
        qty = Math.max(1, Math.min(qty, Math.max(1, r)));
      }
      form.dataset.mode = m;
      if (qIn) qIn.value = qty;
      if (out) out.textContent = qty;
      if (minus) minus.disabled = qty <= 1;
      if (plus) plus.disabled = qty >= Math.max(1, r);
      if (pIn) {
        const p = plan();
        if (m === 'sub' && p) { pIn.value = p.value; pIn.disabled = false; } else { pIn.value = ''; pIn.disabled = true; }
      }
      $$('[data-terms]', form).forEach(u => { const p = plan(); u.hidden = !(p && u.dataset.terms === p.value); });
      const full = r < 1;
      if (btn) { btn.disabled = full; btn.setAttribute('aria-disabled', String(full)); }
      if (priceTag) priceTag.textContent = eur(total());
      if (hint) {
        let h = '';
        if (full) h = limitMsg(m === 'sub');
        else if (m !== 'sub' && CART.once > 0) {
          const n = CART.once + qty, pct = tierPct(n, price);
          h = pct > 0
            ? `Mit ${CART.once} ${CART.once === 1 ? 'Packung' : 'Packungen'} im Warenkorb sind es ${n}: −${pct} % auf alle Packungen im Einzelkauf${TIER_AMT ? ` (${eur(price - tierOff(price, n))} je Packung)` : ''}.`
            : `Ab ${tierMin()} Packungen im Warenkorb gilt Mix & Match: −${tierPct(tierMin(), price)} % auf alle.`;
        }
        hint.textContent = h; hint.classList.toggle('on', !!h);
      }
      if (sticky) {
        const l = $('[data-sticky-label]', sticky), sp = $('[data-sticky-price]', sticky);
        if (l) l.textContent = label();
        if (sp) sp.textContent = eur(total());
      }
    }
    form.addEventListener('change', e => {
      const t = e.target;
      if (t.name === 'lx_mode') { if (t.value === 'once') qty = 1; else if (t.value === 'tier') qty = Math.max(qty, recN()); else qty = 1; }
      if (t.name === 'lx_tq') { qty = parseInt(t.value, 10) || 2; setMode('tier'); }
      if (t.name === 'lx_plan') setMode('sub');
      update();
    });
    form.addEventListener('click', e => {
      const s = e.target.closest('[data-step]');
      if (s && !s.disabled) { qty = Math.max(1, qty + parseInt(s.dataset.step, 10)); update(); }
    });
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const m = mode(); const p = plan();
      if (room(m) < qty) { toast(limitMsg(m === 'sub')); return; }
      const item = { id: parseInt(form.querySelector('[name="id"]').value, 10), quantity: qty };
      if (m === 'sub' && p) item.selling_plan = parseInt(p.value, 10);
      if (btn) btn.classList.add('is-loading');
      try { await cartAdd([item]); openOverlay('cart'); flashDone(btn); if (m !== 'sub') qty = 1; update(); }
      catch (err) { toast(err.message); }
      finally { if (btn) btn.classList.remove('is-loading'); }
    });
    document.addEventListener('lx:cart-updated', update);
    if (sticky) {
      const sb = $('[data-sticky-add]', sticky);
      if (sb) sb.addEventListener('click', () => { if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true })); });
      const cta = $('[data-buy-cta]', form);
      if (cta && 'IntersectionObserver' in window) {
        new IntersectionObserver(([en]) => {
          const show = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-on', show); sticky.setAttribute('aria-hidden', String(!show));
          if (sb) sb.tabIndex = show ? 0 : -1;
          document.body.classList.toggle('has-sticky', show);
        }, { threshold: 0 }).observe(cta);
      }
    }
    if (form.dataset.cOnce != null) { CART.once = parseInt(form.dataset.cOnce, 10) || 0; CART.sub = parseInt(form.dataset.cSub, 10) || 0; }
    update();
  }

  /* ---------- Galerie ---------- */
  function initGallery(g) {
    if (g.dataset.bound) return; g.dataset.bound = '1';
    const track = $('[data-gal-track]', g); if (!track) return;
    const thumbs = $$('[data-slide]', g), dots = $$('.gal-dots i', g);
    const cur = () => Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    const go = i => { i = Math.max(0, Math.min(thumbs.length - 1, i)); track.scrollTo({ left: i * track.clientWidth, behavior: reduceMotion() ? 'auto' : 'smooth' }); };
    thumbs.forEach(b => b.addEventListener('click', () => go(parseInt(b.dataset.slide, 10))));
    $$('[data-gal-step]', g).forEach(b => b.addEventListener('click', () => go(cur() + parseInt(b.dataset.galStep, 10))));
    track.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(cur() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur() - 1); }
    });
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => { const i = cur(); thumbs.forEach((t, k) => t.setAttribute('aria-current', String(k === i))); dots.forEach((d, k) => d.classList.toggle('on', k === i)); });
    }, { passive: true });
  }

  /* ---------- Shop: Filter & Sortierung ---------- */
  function initShop(root) {
    if (root.dataset.bound) return; root.dataset.bound = '1';
    const grid = $('[data-grid]', root); const sel = $('[data-sort]', root); if (!grid) return;
    let filter = 'all';
    function apply() {
      const sort = sel ? sel.value : 'rec';
      const cards = $$('.pcard', grid);
      cards.forEach(c => { c.hidden = !(filter === 'all' || c.dataset.aud === filter); });
      const ordered = cards.slice().sort((a, b) => sort === 'asc' ? a.dataset.price - b.dataset.price : sort === 'desc' ? b.dataset.price - a.dataset.price : a.dataset.pos - b.dataset.pos);
      const promo = $('.promo', grid);
      ordered.forEach(c => grid.insertBefore(c, promo));
    }
    $$('[data-filter]', root).forEach(b => b.addEventListener('click', () => {
      filter = b.dataset.filter;
      $$('[data-filter]', root).forEach(x => x.setAttribute('aria-pressed', String(x === b)));
      apply();
    }));
    if (sel) sel.addEventListener('change', apply);
  }

  /* ---------- Transparenz-Tabs ---------- */
  function initLab(root) {
    if (root.dataset.bound) return; root.dataset.bound = '1';
    const tabs = $$('[data-lab-tab]', root); if (!tabs.length) return;
    function set(id, focus) {
      tabs.forEach(t => { const on = t.dataset.labTab === id; t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1; if (on && focus) t.focus(); });
      $$('[data-lab-panel]', root).forEach(p => { p.hidden = p.dataset.labPanel !== id; });
      $$('[data-lab-hero]', root).forEach(p => { p.hidden = p.dataset.labHero !== id; });
    }
    tabs.forEach(t => t.addEventListener('click', () => set(t.dataset.labTab)));
    const tl = $('.lab-tabs', root);
    if (tl) tl.addEventListener('keydown', e => {
      if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(e.key)) return;
      const i = tabs.indexOf(document.activeElement); if (i < 0) return;
      e.preventDefault();
      let n = i;
      if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
      if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
      if (e.key === 'Home') n = 0;
      if (e.key === 'End') n = tabs.length - 1;
      set(tabs[n].dataset.labTab, true);
    });
    const sel = tabs.find(t => t.getAttribute('aria-selected') === 'true') || tabs[0];
    set(sel.dataset.labTab);
  }

  /* ---------- Akkordeon mit weicher Höhe ---------- */
  function initAccordions(root) {
    $$('.acc details', root).forEach(d => {
      if (d.dataset.bound) return; d.dataset.bound = '1';
      const s = d.querySelector('summary'), c = d.querySelector('.acc-c'); if (!s || !c) return;
      s.addEventListener('click', e => {
        if (reduceMotion()) return;
        e.preventDefault();
        if (d.open) {
          c.style.height = c.scrollHeight + 'px';
          requestAnimationFrame(() => { c.style.transition = 'height .35s cubic-bezier(.22,.7,.12,1)'; c.style.height = '0px'; });
          c.addEventListener('transitionend', () => { d.open = false; c.style.cssText = ''; }, { once: true });
        } else {
          d.open = true; const h = c.scrollHeight; c.style.height = '0px';
          requestAnimationFrame(() => { c.style.transition = 'height .4s cubic-bezier(.22,.7,.12,1)'; c.style.height = h + 'px'; });
          c.addEventListener('transitionend', () => { c.style.cssText = ''; }, { once: true });
        }
      });
    });
  }

  /* ---------- Routine-Finder ---------- */
  const WHAT_ORDER = ['collagen', 'immune-booster', 'cell-booster-adult', 'nad-booster'];
  function finderData() {
    const list = Object.keys(P).map(h => Object.assign({ handle: h }, P[h]));
    const adults = list.filter(p => p.aud !== 'kids').sort((a, b) => {
      const ia = WHAT_ORDER.indexOf(a.handle), ib = WHAT_ORDER.indexOf(b.handle);
      return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
    });
    const kids = list.find(p => p.aud === 'kids');
    const withSub = list.find(p => p.sub && p.price);
    const pct = withSub ? Math.round((1 - withSub.sub / withSub.price) * 100) : 0;
    return { adults, kids, pct };
  }
  function makeFinder(mount) {
    const D = finderData();
    if (!D.adults.length && !D.kids) return { reset() {} };
    const t3 = tierPct(3, (D.adults[0] || D.kids || {}).price || 0);
    const subP = list => list.map(p => p.sub && p.price ? Math.round((1 - p.sub / p.price) * 100) : 0).reduce((a, b) => Math.max(a, b), 0);
    const subPct = subP([...D.adults, D.kids].filter(Boolean));
    const subMo = (D.adults.find(p => p.subMo) || D.kids || {}).subMo || 0;
    const subName = (CFG.subLabel || 'Sparabo') + (subMo ? ` ${subMo} Monate` : ' flexibel');
    const Q = {
      who: { q: 'Für wen suchst du einen Strip?', two: true, opts: [
        { v: 'me', t: 'Für mich', s: 'Erwachsene', ic: 'i-user' },
        { v: 'kid', t: 'Für mein Kind', s: 'Ab 3 Jahren', ic: 'i-users' }
      ] },
      what: { q: 'Was möchtest du täglich nehmen?', two: false, opts: D.adults.map(p => ({ v: p.handle, t: p.ft || p.title, s: p.fs || '', img: p.img })) },
      how: { q: 'Wie möchtest du starten?', two: false, opts: [
        { v: 'once', t: 'Erst einmal ausprobieren', s: '1 Packung · 30 Strips', ic: 'i-sachet' },
        { v: 'tier', t: 'Für drei Monate vorsorgen', s: `3 Packungen · Mix & Match −${t3} %`, ic: 'i-tag' },
        { v: 'sub', t: 'Regelmäßig, ohne daran zu denken', s: `${subName}${subPct ? ` · −${subPct} %` : ''} · monatlich, versandfrei`, ic: 'i-loop' }
      ] }
    };
    const st = { step: 'who', who: null, what: null, how: null, hist: [] };
    const steps = () => {
      if (!D.kids) return ['what', 'how'];
      return st.who === 'kid' ? ['who', 'how'] : ['who', 'what', 'how'];
    };
    if (!D.kids) st.step = 'what';
    function render() {
      if (st.step === 'result') return renderResult();
      const q = Q[st.step]; const list = steps(); const idx = list.indexOf(st.step);
      const prog = list.map((_, i) => `<i class="${i <= idx ? 'on' : ''}"></i>`).join('');
      const opts = q.opts.map(o => {
        const lead = o.img ? `<span class="oi"><img src="${esc(o.img)}" alt="" width="40" height="40" loading="lazy"></span>` : `<span class="oi">${icon(o.ic)}</span>`;
        return `<button type="button" class="opt" data-fv="${esc(o.v)}" aria-pressed="${st[st.step] === o.v}">${lead}<span><b>${esc(o.t)}</b><span>${esc(o.s)}</span></span>${icon('i-arrow', 'arr')}</button>`;
      }).join('');
      mount.innerHTML = `<div class="fq" aria-live="polite">
        <div class="fq-top"><div class="fprog" role="progressbar" aria-valuemin="1" aria-valuemax="${list.length}" aria-valuenow="${idx + 1}" aria-label="Frage ${idx + 1} von ${list.length}">${prog}</div>${st.hist.length ? `<button type="button" class="fback" data-fback>${icon('i-arrow')}Zurück</button>` : ''}</div>
        <h3>${esc(q.q)}</h3>
        <div class="opts${q.two ? ' two' : ''}">${opts}</div>
      </div>`;
    }
    function renderResult() {
      const p = st.who === 'kid' && D.kids ? D.kids : (D.adults.find(x => x.handle === st.what) || D.adults[0]);
      let m = st.how || 'once';
      if (m === 'sub' && !(p.plan && p.sub)) m = 'once';
      const price = m === 'tier' ? p.tier3 : m === 'sub' ? p.sub : p.price;
      const cmp = m === 'tier' ? p.price * 3 : m === 'sub' ? p.price : (p.was > p.price ? p.was : null);
      const label = m === 'once' ? 'Einzelkauf' : m === 'tier' ? `Mix & Match · 3 Packungen` : `${CFG.subLabel || 'Sparabo'}${p.subMo ? ` ${p.subMo} Monate · Mindestlaufzeit ${p.subMo} Monate` : ' flexibel'} · je Lieferung`;
      const qty = m === 'tier' ? 3 : 1;
      let alt = '';
      if (p.handle === 'cell-booster-adult' && P['immune-booster']) alt = `<p class="fres-alt">Lieber ohne Koffein? <a href="${esc(P['immune-booster'].url)}">${P['immune-booster'].html}</a> enthält ebenfalls Vitamin D3 und ist koffeinfrei.</p>`;
      else if (p.aud === 'kids') alt = `<p class="fres-alt">Für Erwachsene in der Familie: <a href="${esc(CFG.shopUrl || R.root)}">alle Produkte im Vergleich</a>.</p>`;
      const add = p.avail
        ? `<button class="btn btn-primary" type="button" data-lx-add data-variant="${p.vid}" data-qty="${qty}"${m === 'sub' ? ` data-plan="${p.plan}"` : ''}>In den Warenkorb</button>`
        : `<button class="btn btn-primary" type="button" disabled>Derzeit nicht verfügbar</button>`;
      mount.innerHTML = `<div class="fq" aria-live="polite">
        <div class="fq-top"><p class="eyebrow">Dein Vorschlag</p><button type="button" class="fback" data-freset>${icon('i-arrow')}Neu starten</button></div>
        <div class="fres">
          <a class="fres-img" href="${esc(p.url)}"><img src="${esc(p.img)}" alt="${esc(p.title)}" width="360" height="360"></a>
          <div style="display:flex;flex-direction:column;gap:12px">
            <h3 class="h3">${p.html}</h3>
            ${p.why ? `<p class="fres-why">${esc(p.why)}</p>` : ''}
            <div class="fres-price"><b>${eur(price)}</b>${cmp && cmp > price ? `<s>${eur(cmp)}</s>` : ''}<span class="muted" style="font-size:13px">${esc(label)}</span></div>
            <div style="display:flex;flex-wrap:wrap;gap:10px;margin-top:4px">${add}<a class="btn btn-ghost" href="${esc(p.url)}">Produkt ansehen</a></div>
            ${alt}
          </div>
        </div>
      </div>`;
    }
    function focusFirst() { const f = mount.querySelector('.opt, .fres a, .fres button'); if (f) f.focus({ preventScroll: true }); }
    function reset() { Object.assign(st, { step: D.kids ? 'who' : 'what', who: null, what: null, how: null, hist: [] }); render(); }
    mount.addEventListener('click', e => {
      const b = e.target.closest('[data-fv]');
      if (b) {
        st[st.step] = b.dataset.fv; st.hist.push(st.step);
        const list = steps(); const i = list.indexOf(st.step);
        st.step = i < list.length - 1 ? list[i + 1] : 'result';
        render(); focusFirst(); return;
      }
      if (e.target.closest('[data-fback]')) { st.step = st.hist.pop() || steps()[0]; render(); focusFirst(); return; }
      if (e.target.closest('[data-freset]')) { reset(); focusFirst(); }
    });
    reset();
    return { reset };
  }

  /* ---------- Vorschlagssuche ---------- */
  let sT, sCtrl;
  function renderSearch(q, data) {
    const res = $('#search-res'), empty = $('#search-empty'); if (!res) return;
    const r = (data && data.resources && data.resources.results) || {};
    const prods = r.products || [], pages = r.pages || [], arts = r.articles || [];
    const rows = [];
    prods.forEach(p => {
      const meta = P[p.handle] || {};
      const img = meta.img || (p.featured_image && p.featured_image.url) || p.image || '';
      const regular = p.price != null ? parseFloat(p.price) * 100 : null;
      const useAb = CFG.template !== 'product' && meta.ab && regular != null && meta.ab < regular;
      const wasC = p.compare_at_price_max != null ? parseFloat(p.compare_at_price_max) * 100 : 0;
      const price = regular == null ? '' : useAb ? `<span class="ab">ab</span> ${eur(meta.ab)}` : (wasC > regular ? `<s class="was">${eur(wasC)}</s> ` : '') + eur(regular);
      rows.push(`<a href="${esc(p.url)}" role="option">${img ? `<img src="${esc(img)}" alt="" width="56" height="56">` : '<span></span>'}<span class="sr-t"><b>${meta.html || esc(p.title)}</b>${meta.ft ? `<span class="sr-s">${esc(meta.fs || '')}</span>` : ''}</span><span class="mono" style="font-size:14px">${price}</span></a>`);
    });
    pages.forEach(p => rows.push(`<a href="${esc(p.url)}" role="option"><span style="width:56px;height:56px;border-radius:10px;background:var(--mist);display:grid;place-items:center">${icon('i-doc')}</span><span class="sr-t"><b>${esc(p.title)}</b><span class="sr-s">Seite</span></span><span></span></a>`));
    arts.forEach(p => rows.push(`<a href="${esc(p.url)}" role="option"><span style="width:56px;height:56px;border-radius:10px;background:var(--mist);display:grid;place-items:center">${icon('i-doc')}</span><span class="sr-t"><b>${esc(p.title)}</b><span class="sr-s">Magazin</span></span><span></span></a>`));
    if (empty) empty.hidden = true;
    res.innerHTML = rows.join('') || `<p class="search-hint">Keine Treffer für „${esc(q)}“. Versuch es mit einem Inhaltsstoff wie „Zink“ oder „Kollagen“.</p>`;
  }
  function doSearch(q) {
    const res = $('#search-res'), empty = $('#search-empty'); if (!res) return;
    q = q.trim();
    clearTimeout(sT);
    if (!q) { res.innerHTML = ''; if (empty) empty.hidden = false; return; }
    sT = setTimeout(async () => {
      try {
        if (sCtrl) sCtrl.abort();
        sCtrl = 'AbortController' in window ? new AbortController() : null;
        const url = `${R.predictive}.json?q=${encodeURIComponent(q)}&resources[type]=product,page,article&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag,body`;
        const r = await fetch(url, { signal: sCtrl ? sCtrl.signal : undefined, headers: { Accept: 'application/json' } });
        if (!r.ok) throw new Error('search');
        renderSearch(q, await r.json());
      } catch (e) { if (e.name !== 'AbortError') res.innerHTML = `<p class="search-hint">Die Suche ist gerade nicht erreichbar. Drücke Enter für die Ergebnisseite.</p>`; }
    }, 160);
  }
  document.addEventListener('input', e => { if (e.target && e.target.id === 'q') doSearch(e.target.value); });

  /* ---------- Globale Klicks ---------- */
  document.addEventListener('click', async e => {
    const t = e.target;
    const fin = t.closest('[data-finder]');
    if (fin) { if (openOverlay('finder')) { e.preventDefault(); } return; }
    const op = t.closest('[data-open]');
    if (op) { if (openOverlay(op.dataset.open)) e.preventDefault(); return; }
    const add = t.closest('[data-lx-add]');
    if (add) {
      e.preventDefault();
      if (add.classList.contains('is-loading')) return;
      const item = { id: parseInt(add.dataset.variant, 10), quantity: parseInt(add.dataset.qty, 10) || 1 };
      if (add.dataset.plan) item.selling_plan = parseInt(add.dataset.plan, 10);
      const isSub = !!item.selling_plan;
      if ((isSub ? CART.sub + item.quantity > MAX_SUB : CART.once + item.quantity > MAX_ONCE)) { toast(limitMsg(isSub)); return; }
      add.classList.add('is-loading');
      try {
        await cartAdd([item]);
        if (add.hasAttribute('data-xs')) {
          cartSay(`${(add.dataset.name || 'Produkt').replace(/[™®]/g, '')} hinzugefügt.`);
          // neue Position kurz hervorheben
          const nl = $$(`.line-item[data-key^="${item.id}:"]`).filter(x => x.offsetParent !== null)[0];
          if (nl) { nl.classList.add('is-new'); nl.scrollIntoView({ block: 'nearest', behavior: reduceMotion() ? 'auto' : 'smooth' }); }
          return;
        }
        if (add.classList.contains('quick')) {
          add.classList.add('is-done'); add.innerHTML = icon('i-check') + '<span class="lbl">Hinzugefügt</span>';
          setTimeout(() => { add.classList.remove('is-done'); add.innerHTML = icon('i-plus') + '<span class="lbl">In den Warenkorb</span>'; }, 1600);
        }
        if (!openOverlay('cart')) toast('Zum Warenkorb hinzugefügt.');
      } catch (err) { toast(err.message); }
      finally { add.classList.remove('is-loading'); }
      return;
    }
    const pl = t.closest('[data-cplan]');
    if (pl) {
      e.preventDefault();
      if (pl.classList.contains('is-loading')) return;
      const li = pl.closest('.line-item'); if (li) li.style.opacity = '.5';
      pl.classList.add('is-loading');
      try { await cartPlan(parseInt(pl.dataset.line, 10), parseInt(pl.dataset.q, 10) || 1, parseInt(pl.dataset.cplan, 10)); if (pl.dataset.done) cartSay(pl.dataset.done + '.'); }
      catch (err) { toast(err.message); if (li) li.style.opacity = ''; pl.classList.remove('is-loading'); }
      return;
    }
    const cq = t.closest('[data-cq]');
    if (cq) {
      e.preventDefault();
      if (cq.disabled || cq.getAttribute('aria-disabled') === 'true') { toast(cq.title || limitMsg(false)); return; }
      const li = cq.closest('.line-item'); if (li) li.style.opacity = '.5';
      try { await cartChange(cq.dataset.cq, Math.max(0, parseInt(cq.dataset.q, 10) || 0)); if (cq.dataset.done) cartSay(cq.dataset.done + '.'); }
      catch (err) { toast(err.message); if (li) li.style.opacity = ''; }
      return;
    }
    if (t.closest('[data-close-all]')) { const a = t.closest('a[href]'); closeOverlays(!!a); return; }
    const qb = t.closest('[data-q]');
    if (qb && qb.closest('.search')) { const q = $('#q'); if (q) { q.value = qb.dataset.q; doSearch(qb.dataset.q); q.focus(); } return; }
    const cp = t.closest('[data-copy]');
    if (cp) {
      const v = cp.dataset.copy;
      const done = () => { const o = cp.textContent; cp.textContent = 'Kopiert'; setTimeout(() => { cp.textContent = o; }, 1600); };
      try { navigator.clipboard.writeText(v).then(done, () => toast(v)); } catch (err) { toast(v); }
      return;
    }
    const sc = t.closest('[data-scroll]');
    if (sc) { const el = document.getElementById(sc.dataset.scroll); if (el) { e.preventDefault(); el.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'start' }); } return; }
    const ck = t.closest('[data-cookie-settings]');
    if (ck) {
      e.preventDefault();
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') window.privacyBanner.showPreferences();
      else toast('Die Cookie-Einstellungen sind gerade nicht verfügbar. Bitte lade die Seite neu.');
      return;
    }
    if (openPanel && t.closest('a[href]') && !t.closest('[data-open]')) closeOverlays(true);
  });

  /* Newsletter: Prüfung vor dem Absenden (gesendet wird über das Shopify-Formular) */
  document.addEventListener('submit', e => {
    const f = e.target;
    if (f.classList && f.classList.contains('nl')) {
      const inp = f.querySelector('input[type=email]');
      if (inp && (!inp.value || !/^\S+@\S+\.\S+$/.test(inp.value))) {
        e.preventDefault(); inp.setAttribute('aria-invalid', 'true'); inp.focus();
        toast('Bitte gib eine gültige E-Mail-Adresse ein.');
      }
    }
  }, true);

  /* Anmerkung zur Bestellung (Warenkorbseite) */
  document.addEventListener('change', e => {
    const n = e.target.closest && e.target.closest('[data-cart-note]');
    if (n) fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: n.value }) }).catch(() => {});
  });

  /* ---------- 3D-Produktbühne (Startseite): fotorealistische Studio-Aufnahmen ----------
     Je Produkt eine Bildfolge der Faltschachtel (−45° … +75° in 3°-Schritten, Ruhelage +15°)
     und ein Bild des Sachets – gerendert aus den 3D-Modellen, mit Bodenspiegelung.
     Ziehen verschiebt das Set und dreht die Schachtel, Loslassen wechselt das Produkt
     (Schachtel dreht nach links hinaus, die nächste von rechts herein). Weiter: Pfeile, Punkte,
     Pfeiltasten, Tippen neben die Packung. Tippen auf die Packung bzw. „Zum Produkt“ öffnet die
     Produktseite. Bilder werden nach Bedarf geladen (zuerst nur das Startbild). */
  const ST3 = { A0: -45, STEP: 3, N: 41, REST: 20 };
  ST3.A1 = ST3.A0 + (ST3.N - 1) * ST3.STEP;   // +75°
  ST3.RA = ST3.A0 + ST3.REST * ST3.STEP;      // +15° (Ruhelage)
  const clamp01 = v => v < 0 ? 0 : v > 1 ? 1 : v;
  const easeOut3 = t => 1 - Math.pow(1 - t, 3);
  const easeOut4 = t => 1 - Math.pow(1 - t, 4);
  const easeInOut = t => t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

  function initStage(st) {
    if (st.dataset.bound) return; st.dataset.bound = '1';
    const slides = $$('.st3-slide', st), items = $$('[data-item]', st), dots = $$('[data-stage-dot]', st);
    const live = $('[data-stage-live]', st);
    const goLink = $('[data-stage-go]', st), goName = $('[data-stage-go-name]', st);
    const cv = $('.st3-cv', st), probe = $('.st3-probe', st);
    const n = slides.length;
    if (n < 2) $$('.stage-arrows, .stage-dots', st).forEach(e => { e.hidden = true; });
    const ctx = cv && cv.getContext ? cv.getContext('2d') : null;
    const geo = (st.dataset.st3Geo || '').split('|').map(r => r.split(',').map(Number));
    if (!ctx || !probe || !n || geo.length < 4 || geo.some(r => r.some(v => isNaN(v)))) return; // Startbild bleibt stehen
    const [U, B, S, G] = geo;                 // Ausschnitte im Kamerabild (x0,x1,y0,y1; y von unten), G = Rand, Bodenlinie
    const MG = G[0], FY = G[1];
    const sets = slides.map(el => ({ f: el.dataset.f || '', s: el.dataset.s || '', one: el.dataset.img || '' }));

    /* Laden: nur was gebraucht wird, nächstgelegene Drehwinkel zuerst */
    const saveData = !!(navigator.connection && navigator.connection.saveData);
    let size = '';
    const cache = new Map(), Q = [];
    let busy = 0;
    const keyOf = (si, i) => size + '|' + si + '|' + i;
    const urlOf = (set, i, sz) => i === -2 ? set.one : i === -1 ? set.s.replace('-l-s.', '-' + sz + '-s.') : set.f.replace('-l-00.', '-' + sz + '-' + String(i).padStart(2, '0') + '.');
    function want(si, i, prio) {
      const set = sets[si]; if (!set || !size) return;
      if ((i >= -1 && !set.f) || (i === -2 && !set.one)) return;
      const k = keyOf(si, i); let e = cache.get(k);
      if (!e) { e = { si, i, sz: size, state: 0, prio, img: null }; cache.set(k, e); Q.push(e); }
      else if (e.state === 0 && prio < e.prio) e.prio = prio;
      pump();
    }
    function pump() {
      if (!Q.length) return;
      Q.sort((a, b) => a.prio - b.prio);
      while (busy < 4 && Q.length) {
        const e = Q.shift(); if (e.state !== 0) continue;
        e.state = 1; busy++;
        const img = new Image(); img.decoding = 'async';
        img.src = urlOf(sets[e.si], e.i, e.sz);
        const fin = ok => { busy--; e.state = ok ? 2 : 3; if (ok) { e.img = img; ready(e); } else failed(e); pump(); };
        (img.decode ? img.decode() : new Promise((res, rej) => { img.onload = res; img.onerror = rej; })).then(() => fin(true), () => fin(img.complete && img.naturalWidth > 0));
      }
    }
    const get = (si, i) => { const e = cache.get(keyOf(si, i)); return e && e.state === 2 ? e.img : null; };
    function wantArc(si, a0, a1, base) {           // Bilder entlang einer Drehung (Start → Ziel)
      const set = sets[si]; if (!set) return;
      if (!set.f) { want(si, -2, base); return; }
      want(si, -1, base);
      const i0 = (a0 - ST3.A0) / ST3.STEP, i1 = (a1 - ST3.A0) / ST3.STEP, steps = Math.ceil(Math.abs(i1 - i0));
      for (let k = 0; k <= steps; k++) { const i = Math.round(i0 + (i1 - i0) * (steps ? k / steps : 0)); if (i >= 0 && i < ST3.N) want(si, i, base + k * 0.5); }
    }
    function wantAll(si, ang, base) {               // alle Winkel, nach Abstand zum aktuellen
      const set = sets[si]; if (!set) return;
      if (!set.f) { want(si, -2, base); return; }
      want(si, -1, base);
      const c = (ang - ST3.A0) / ST3.STEP;
      for (let i = 0; i < ST3.N; i++) want(si, i, base + Math.abs(i - c));
    }
    function arcReady(si, a0, a1) {                // sind genug Bilder für eine sichtbare Drehung da?
      const set = sets[si]; if (!set || !set.f) return false;
      const i0 = Math.round((a0 - ST3.A0) / ST3.STEP), i1 = Math.round((a1 - ST3.A0) / ST3.STEP), d = i1 > i0 ? 1 : -1;
      for (let i = i0; d > 0 ? i <= i1 : i >= i1; i += d) { if ((i - i0) % 4 === 0 && !get(si, Math.max(0, Math.min(ST3.N - 1, i)))) return false; }
      return !!get(si, Math.max(0, Math.min(ST3.N - 1, i1)));
    }
    function wantArcs(si, base) {                   // Bögen für Übergänge (jedes 4. Bild): herein von beiden Seiten
      const set = sets[si]; if (!set) return;
      if (!set.f) { want(si, -2, base); return; }
      want(si, ST3.REST, base); want(si, -1, base + .5);
      for (let i = 0; i < ST3.N; i += 4) want(si, i, base + 2 + Math.abs(i - ST3.REST) / 4);
    }

    /* Bild wählen: zwei benachbarte Winkel überblenden, sonst nächstgelegenes geladenes Bild */
    let lastMotion = 0, qT = 0;
    function pick(si, ang) {
      let fi = Math.max(0, Math.min(ST3.N - 1, (ang - ST3.A0) / ST3.STEP));
      if (performance.now() - lastMotion > 150 && !tw && !env) fi = Math.round(fi);
      const i0 = Math.floor(fi), i1 = Math.min(ST3.N - 1, i0 + 1), t = fi - i0;
      const a = get(si, i0), b = get(si, i1);
      if (a && (b || t < .004)) return [a, t < .004 ? null : b, t];
      if (a && t < .5) return [a, null, 0];
      if (b && t >= .5) return [b, null, 0];
      const c = Math.round(fi);
      for (let d = 0; d < ST3.N; d++) {
        const lo = get(si, c - d); if (lo) return [lo, null, 0];
        const hi = get(si, c + d); if (hi) return [hi, null, 0];
      }
      return [null, null, 0];
    }

    /* Darstellung */
    let L = null, dpr = 1;
    function layout() {
      const sr = st.getBoundingClientRect(), pr = probe.getBoundingClientRect();
      if (!sr.width || !pr.height) return false;
      dpr = Math.min(window.devicePixelRatio || 1, 3);
      if (sr.width * sr.height * dpr * dpr > 4e6) dpr = Math.sqrt(4e6 / (sr.width * sr.height));   // Canvas höchstens ca. 4 Megapixel
      const W = Math.round(sr.width * dpr), H = Math.round(sr.height * dpr);
      if (cv.width !== W || cv.height !== H) { cv.width = W; cv.height = H; }
      L = { x: pr.left - sr.left, y: pr.top - sr.top, k: pr.height / (U[3] - U[2]), W: sr.width, H: sr.height };
      if (!size) {
        // Bildgröße einmal festlegen – wie das Startbild, sonst nach Darstellungsgröße × Pixeldichte
        const poster = $('.st3-b', st), cs = poster && poster.currentSrc;
        size = st.dataset.st3Size || (cs && /-[lm]-20\./.test(cs) ? (cs.includes('-l-20.') ? 'l' : 'm') : ((B[1] - B[0]) * L.k * (window.devicePixelRatio || 1) > 520 ? 'l' : 'm'));
      }
      return true;
    }
    const rectOf = (R, tx) => [L.x + (R[0] - U[0]) * L.k + tx, L.y + (U[3] - R[3]) * L.k, (R[1] - R[0]) * L.k, (R[3] - R[2]) * L.k];
    function drawSet(si, tx, ang, alpha) {
      const set = sets[si]; if (!set || alpha <= .003) return;
      if (set.f) {
        const [a, b, t] = pick(si, ang), r = rectOf(B, tx);
        if (a) { ctx.globalAlpha = alpha; ctx.drawImage(a, r[0], r[1], r[2], r[3]); }
        if (b && t > .004) { ctx.globalAlpha = alpha * t; ctx.drawImage(b, r[0], r[1], r[2], r[3]); }
        const s = get(si, -1);
        if (s) { const q = rectOf(S, tx); ctx.globalAlpha = alpha; ctx.drawImage(s, q[0], q[1], q[2], q[3]); }
      } else {
        const im = get(si, -2); if (!im) return;
        // ohne 3D-Bilder: Produktbild im Bereich der Schachtel
        const r = rectOf([B[0] + MG, S[1] - MG, FY, B[3]], tx), sc = Math.min(r[2] / im.naturalWidth, r[3] / im.naturalHeight);
        const w = im.naturalWidth * sc, h = im.naturalHeight * sc;
        ctx.globalAlpha = alpha; ctx.drawImage(im, r[0] + (r[2] - w) / 2, r[1] + r[3] - h, w, h);
      }
    }

    /* Zustand: aktuelles Set (V) und ggf. hinausdrehendes Set (O) */
    let cur = Math.max(0, slides.findIndex(s => s.classList.contains('is-active')));
    const V = { tx: 0, a: ST3.RA, o: 1 };
    let O = null, tw = null, ticking = false, lastDraw = 0, on = false;
    let lockUntil = 0, interacted = false, auto = null, visible = true, hovering = false, focused = false, peeked = false, dragging = false;
    let swayHold = 0, env = 0, envT = 0, swayNow = 0;
    const swayP0 = performance.now();
    const wantsSway = st.dataset.sway !== 'false';
    const swayReady = () => [-2, -1, 0, 1, 2].every(d => get(cur, ST3.REST + d));
    const swayAllowed = () => wantsSway && on && visible && !document.hidden && !dragging && !tw && !O && !reduceMotion() && Date.now() > swayHold && V.tx === 0 && Math.abs(V.a - ST3.RA) < .01 && !!sets[cur].f && swayReady();
    // Leerlauf: Schachtel dreht sich langsam um ±6,5° (weich ein- und ausgeblendet)
    function swayVal(now) {
      const dt = envT ? Math.min(100, now - envT) : 16; envT = now;
      env = swayAllowed() ? Math.min(1, env + dt / 2200) : Math.max(0, env - dt / 650);
      return env > 0 ? 6.5 * Math.sin((now - swayP0) / 9000 * Math.PI * 2) * easeInOut(env) : 0;
    }
    function draw(now) {
      if (!on || (!L && !layout())) return;
      ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, cv.width, cv.height);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high';
      if (O) drawSet(O.si, O.tx, O.a, O.o);
      drawSet(cur, V.tx, V.a + swayNow, V.o);
      ctx.globalAlpha = 1; lastDraw = now;
    }
    function tick(now) {
      ticking = false;
      let more = false;
      if (tw) {
        const el = now - tw.t0; tw.step(Math.min(el, tw.dur));
        if (el >= tw.dur) { const d = tw.done; tw = null; if (d) d(); } else more = true;
      }
      swayNow = swayVal(now);
      const idle = !more && env > 0;
      // Leerlauf-Drehung mit ca. 30 Bildern/s, Bewegungen mit voller Bildrate
      if (!idle || now - lastDraw > 30) draw(now);
      if (more || env > 0 || swayAllowed()) kick();
    }
    function kick() { if (!ticking) { ticking = true; requestAnimationFrame(tick); } }
    function tween(dur, step, done) { tw = { t0: performance.now(), dur, step, done }; kick(); }
    // Leerlauf-Drehung in die Position übernehmen (kein Sprung beim Anfassen)
    function settle() { if (swayNow) V.a = Math.max(ST3.A0, Math.min(ST3.A1, V.a + swayNow)); swayNow = 0; env = 0; }
    const hold = ms => { swayHold = Date.now() + ms; };

    function ready(e) {
      if (!on && e.si === cur && get(cur, ST3.REST) !== null && (get(cur, -1) || !sets[cur].s)) takeover();
      else if (!on && e.si === cur && !sets[cur].f && e.i === -2) takeover();
      if (on && (e.si === cur || (O && e.si === O.si))) kick();
    }
    function failed(e) { if (!on && e.si === cur && e.i === -1 && get(cur, ST3.REST)) takeover(); }
    function takeover() { if (on) return; on = true; layout(); st.classList.add('st3-on'); kick(); }

    function setInfo(i, announce) {
      items.forEach((it, k) => {
        const act = k === i;
        it.classList.toggle('is-active', act);
        if (act) it.removeAttribute('aria-hidden'); else it.setAttribute('aria-hidden', 'true');
        const a = it.querySelector('a');
        if (a) { if (act) a.removeAttribute('tabindex'); else a.tabIndex = -1; }
      });
      slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
      dots.forEach((d, k) => { if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      const nm = items[i] && items[i].querySelector('.stage-name');
      const name = nm ? nm.textContent.replace(/\s+/g, ' ').trim() : '';
      if (goLink && nm) { goLink.href = nm.getAttribute('href'); if (goName) goName.textContent = ': ' + name; }
      if (announce && live) live.textContent = `${name} – ${i + 1} von ${n}`;
    }
    function snapBack() {
      st.classList.remove('is-dragging');
      const t0 = V.tx, a0 = V.a;
      if (!t0 && Math.abs(a0 - ST3.RA) < .01) { kick(); return; }
      tween(reduceMotion() ? 200 : 560, el => { const p = easeOut3(el / (reduceMotion() ? 200 : 560)); V.tx = t0 * (1 - p); V.a = a0 + (ST3.RA - a0) * p; }, () => { V.tx = 0; V.a = ST3.RA; hold(1800); });
    }
    function go(to, dir, opts) {
      opts = opts || {};
      to = ((to % n) + n) % n;
      if (to === cur) { snapBack(); return; }
      const now = Date.now();
      if (now < lockUntil && !opts.force) return;
      lockUntil = now + 380;
      dir = dir || (to > cur ? 1 : -1);
      settle(); st.classList.remove('is-dragging', 'is-peek');
      const rm = reduceMotion(), W = L ? L.W : 600, dist = W * .62;
      const o0 = { si: cur, tx: V.tx, a: V.a, o: V.o };
      const outTx = dir > 0 ? -dist : dist, outA = dir > 0 ? ST3.A0 : ST3.A1;
      const inTx = dir > 0 ? dist : -dist, inA = dir > 0 ? ST3.A1 : ST3.A0;
      O = Object.assign({}, o0);
      cur = to;
      setInfo(cur, !opts.silent);
      const rotOut = !rm && arcReady(o0.si, o0.a, outA), rotIn = !rm && arcReady(cur, inA, ST3.RA);
      const outA2 = rotOut ? outA : o0.a, inA2 = rotIn ? inA : ST3.RA;
      V.tx = rm ? 0 : inTx; V.a = inA2; V.o = 0;
      if (!rm) { wantArc(o0.si, o0.a, outA, 0); wantArc(cur, inA, ST3.RA, 0); } else { want(cur, ST3.REST, 0); want(cur, -1, 0); want(cur, -2, 0); }
      const DO = rm ? 320 : 760, DI = rm ? 320 : 920, D = Math.max(DO, DI);
      tween(D, el => {
        const po = easeOut3(clamp01(el / DO)), pi = easeOut4(clamp01(el / DI));
        if (!rm) {
          O.tx = o0.tx + (outTx - o0.tx) * po; O.a = o0.a + (outA2 - o0.a) * po;
          V.tx = inTx * (1 - pi); V.a = inA2 + (ST3.RA - inA2) * pi;
          O.o = o0.o * (1 - clamp01((el - 220) / 380)); V.o = clamp01((el - 40) / 420);
        } else { O.o = o0.o * (1 - clamp01(el / DO)); V.o = clamp01(el / DI); }
      }, () => { O = null; V.tx = 0; V.a = ST3.RA; V.o = 1; hold(1200); if (interacted) prime(); });
      for (let d = 1; d <= 2; d++) { want(cur, ST3.REST - d, 24 + d); want(cur, ST3.REST + d, 24 + d); }
      // Nachbarn für weitere Wechsel vormerken
      wantArcs((cur + dir + n) % n, 60); if (interacted) wantArcs((cur - dir + n) % n, 70);
    }
    const user = () => { interacted = true; stopAuto(); st.classList.remove('is-peek'); hold(3000); };
    // Erste Absicht zur Bedienung: alle Winkel des aktuellen Produkts laden
    let primed = -1;
    const prime = () => {
      if (!size || primed === cur) return; primed = cur;
      wantAll(cur, V.a, 2);
      if (n > 1) { wantArcs((cur + 1) % n, 30); wantArcs((cur - 1 + n) % n, 36); }
    };

    /* Pfeile, Punkte, Tastatur */
    $$('[data-stage-step]', st).forEach(b => b.addEventListener('click', () => {
      user(); const s = parseInt(b.dataset.stageStep, 10) || 1; go(cur + s, s > 0 ? 1 : -1);
    }));
    dots.forEach(d => d.addEventListener('click', () => {
      user(); const i = parseInt(d.dataset.stageDot, 10); if (i !== cur) go(i, i > cur ? 1 : -1);
    }));
    st.addEventListener('keydown', e => {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault(); user();
      const s = e.key === 'ArrowRight' ? 1 : -1; go(cur + s, s);
    });

    /* Ziehen (verschieben + drehen) und Tippen */
    let pid = null, x0 = 0, y0 = 0, t0 = 0, dx = 0, moved = false, a0 = ST3.RA, tx0 = 0;
    st.addEventListener('pointerdown', e => {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      prime();
      if (e.target.closest('a, button')) return;
      pid = e.pointerId; x0 = e.clientX; y0 = e.clientY; t0 = Date.now(); dx = 0; dragging = false; moved = false;
    });
    st.addEventListener('pointermove', e => {
      if (e.pointerId !== pid) return;
      const mx = e.clientX - x0, my = e.clientY - y0;
      if (!dragging) {
        if (Math.abs(mx) < 8 && Math.abs(my) < 8) return;
        moved = true;
        if (Math.abs(my) > Math.abs(mx)) { pid = null; return; } // senkrecht = Seite scrollen
        dragging = true; user(); settle();
        if (tw && !O) tw = null;                 // Zurückfedern abbrechen, Bewegung übernehmen
        a0 = V.a; tx0 = V.tx; x0 = e.clientX;
        st.classList.add('is-dragging');
        try { st.setPointerCapture(e.pointerId); } catch (err) { /* ignorieren */ }
      }
      dx = e.clientX - x0;
      if (O) return;                             // Übergang läuft noch
      V.tx = tx0 + dx * .6;
      V.a = Math.max(ST3.A0, Math.min(ST3.A1, a0 + dx * .26));
      lastMotion = performance.now(); clearTimeout(qT); qT = setTimeout(kick, 170);
      kick();
    });
    function endPointer(e, cancel) {
      if (e.pointerId !== pid) return;
      pid = null;
      if (dragging) {
        dragging = false;
        const thr = Date.now() - t0 < 300 ? 24 : 56;
        if (!cancel && dx <= -thr) go(cur + 1, 1, { force: true });
        else if (!cancel && dx >= thr) go(cur - 1, -1, { force: true });
        else snapBack();
        return;
      }
      if (cancel || moved || e.target.closest('.stage-info, .spec, .stage-dots')) return;
      user();
      if (overPack(e.clientX, e.clientY)) { const href = productHref(); if (href) { location.href = href; return; } }
      const r = st.getBoundingClientRect();
      if (n > 1) { if (e.clientX - r.left < r.width * .34) go(cur - 1, -1); else go(cur + 1, 1); }
    }
    function productHref() {
      const nm = items[cur] && items[cur].querySelector('.stage-name');
      return nm ? nm.getAttribute('href') : (goLink ? goLink.getAttribute('href') : '');
    }
    function overPack(x, y) {
      if (!L) return false;
      const sr = st.getBoundingClientRect(), px = x - sr.left, py = y - sr.top, pad = 6;
      return [[B[0] + MG, B[1] - MG], [S[0] + MG, S[1] - MG]].some(([l, r]) => {
        const q = rectOf([l, r, FY, Math.max(B[3], S[3])], V.tx);
        return px >= q[0] - pad && px <= q[0] + q[2] + pad && py >= q[1] - pad && py <= q[1] + q[3] + pad;
      });
    }
    // Maus über der Packung: Hand-Cursor (Klick öffnet das Produkt); Bilder vorladen
    st.addEventListener('pointermove', e => { if (e.pointerType === 'mouse' && pid === null) st.classList.toggle('is-hot', overPack(e.clientX, e.clientY) && !e.target.closest('.stage-info, .spec, .stage-dots')); });
    st.addEventListener('pointerleave', () => st.classList.remove('is-hot'));
    st.addEventListener('pointerup', e => endPointer(e, false));
    st.addEventListener('pointercancel', e => endPointer(e, true));
    // Nur der eigene Capture-Verlust zählt (Touch-Kindelemente melden beim Übernehmen ebenfalls „lost“)
    st.addEventListener('lostpointercapture', e => { if (e.target === st && dragging) { dragging = false; pid = null; snapBack(); } });

    /* Optional: automatisch weiterblättern (pausiert bei Hover, Fokus, außerhalb des Bildschirms) */
    const wantsAuto = st.dataset.autoplay === 'true';
    const canAuto = () => wantsAuto && !interacted && visible && !hovering && !focused && !document.hidden && !reduceMotion() && st.isConnected;
    function stopAuto() { clearInterval(auto); auto = null; }
    function startAuto() { stopAuto(); if (canAuto()) { wantArcs(cur, 40); wantArcs((cur + 1) % n, 44); auto = setInterval(() => { if (canAuto()) go(cur + 1, 1, { silent: true }); else stopAuto(); }, 6500); } }
    st.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') { hovering = true; stopAuto(); prime(); } });
    st.addEventListener('pointerleave', e => { if (e.pointerType === 'mouse') { hovering = false; startAuto(); } });
    st.addEventListener('focusin', () => { focused = true; stopAuto(); prime(); });
    st.addEventListener('focusout', () => { focused = false; startAuto(); });
    document.addEventListener('visibilitychange', () => { if (document.hidden) stopAuto(); else { startAuto(); kick(); } });

    /* Einmaliger Hinweis auf Touch-Geräten: Set wird kurz angezogen und dreht sich */
    function peek() {
      if (peeked || interacted || reduceMotion() || !matchMedia('(hover: none)').matches) return;
      peeked = true;
      if (!saveData) [16, 14, 12].forEach((i, k) => want(cur, i, 12 + k));
      setTimeout(() => {
        if (interacted || !visible || !on || tw || O) { peeked = false; return; }
        settle();
        const W = L ? L.W : 360, a00 = V.a;
        tween(1300, el => { const p = Math.sin(easeInOut(el / 1300) * Math.PI); V.tx = -W * .07 * p; V.a = a00 + (ST3.RA - 24 - a00) * p; }, () => { V.tx = 0; V.a = ST3.RA; hold(800); });
      }, 1600);
    }

    /* Start: Startbild, danach (wenn die Seite geladen ist) die Bilder für die Leerlauf-Drehung und Übergänge */
    let booted = false;
    function boot() {
      if (booted || !layout()) return;
      booted = true;
      want(cur, ST3.REST, 0); want(cur, -1, 0); want(cur, -2, 0);
      const later = () => {
        if (saveData) return;
        for (let d = 1; d <= 2; d++) { want(cur, ST3.REST - d, 8 + d); want(cur, ST3.REST + d, 8 + d); }
        for (let k = 1; k < n; k++) { const si = (cur + k) % n; want(si, ST3.REST, 30 + k); want(si, -1, 30.5 + k); want(si, -2, 30 + k); }
        if (wantsAuto && !saveData) { wantArcs(cur, 50); wantArcs((cur + 1) % n, 60); }
      };
      const idle = window.requestIdleCallback || (f => setTimeout(f, 300));
      if (document.readyState === 'complete') setTimeout(() => idle(later), 600);
      else window.addEventListener('load', () => setTimeout(() => idle(later), 900), { once: true });
    }
    boot();
    const onResize = () => { if (!booted) boot(); else if (layout()) kick(); };
    if ('ResizeObserver' in window) new ResizeObserver(onResize).observe(st);
    else window.addEventListener('resize', onResize);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        visible = en.isIntersecting;
        st.classList.toggle('is-paused', !visible);
        if (visible) { startAuto(); peek(); kick(); } else stopAuto();
      }, { threshold: 0.3 }).observe(st);
    } else startAuto();
  }

  /* ---------- Initialisierung ---------- */
  // Jede Komponente einzeln absichern: ein Fehler (z. B. 3D-Ansicht im Theme-Editor) blockiert nicht die Kaufoptionen
  const safe = (fn, name) => (...a) => { try { return fn(...a); } catch (e) { console.error('[LX] ' + name, e); } };
  function initAll(root) {
    root = root || document;
    safe(initMega, 'mega')();
    $$('[data-lx-buy]', root).forEach(safe(initBuy, 'buy'));
    $$('[data-stage]', root).forEach(safe(initStage, 'stage'));
    $$('[data-gal]', root).forEach(safe(initGallery, 'gallery'));
    $$('[data-lx-shop]', root).forEach(safe(initShop, 'shop'));
    $$('[data-lab]', root).forEach(safe(initLab, 'lab'));
    safe(initAccordions, 'accordions')(root);
    // seitlich wischbare Listen ohne Links/Buttons per Tastatur erreichbar machen (nur wenn sie wirklich scrollen)
    $$('[data-scrollx]', root).forEach(o => {
      const f = () => { if (o.scrollWidth > o.clientWidth + 2) o.tabIndex = 0; else o.removeAttribute('tabindex'); };
      f(); window.addEventListener('resize', f, { passive: true });
    });
    $$('[data-finder-mount]', root).forEach(m => { if (!m.dataset.bound) { m.dataset.bound = '1'; safe(makeFinder, 'finder')(m); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll()); else initAll();
  if (location.hash === '#finder' && !$('[data-finder-mount]')) setTimeout(() => openOverlay('finder'), 300);

  /* Theme-Editor */
  document.addEventListener('shopify:section:load', e => initAll(e.target));
  document.addEventListener('shopify:section:unload', () => { closeOverlays(true); });

  window.LX = { openOverlay, closeOverlays, cartAdd, cartChange, toast };
})();
